import usePublicApiQuery from '@/hooks/api/usePublicApiQuery';
import { App } from '@/models/App';
import { PublicApiBuild } from '@/models/Build';
import BuildStatus from '@/models/BuildStatus';
import { SimpleErrorResponse } from '@/models/Error';
import { PublicApiPagedResponse } from '@/models/network';
import { PipelineStatus } from '@/models/Pipeline';

const usePreviousSuccessfulBuild = (appSlug: App['slug'], build: PublicApiBuild, isViewedAsPublicPage: boolean) => {
  const searchParams: { [key: string]: string } = {
    limit: '1',
    status: PipelineStatus.SUCCEEDED,
  };
  if (build.triggeredWorkflow) {
    searchParams.workflow = build.triggeredWorkflow;
  }
  const urlSearchParams = new URLSearchParams(searchParams);

  if (build.triggeredAt) {
    urlSearchParams.append('before', build.triggeredAt);
  }

  const query = usePublicApiQuery<PublicApiPagedResponse<PublicApiBuild>, SimpleErrorResponse>(
    ['previousSuccessfulBuild', build.slug],
    `/v0.1/apps/${appSlug}/pipelines?${urlSearchParams.toString()}`,
    {
      enabled: !build.pipelineWorkflowId && build.status === BuildStatus.Error,
      requestConfig: {
        publicAccess: isViewedAsPublicPage,
      },
    },
  );
  return { ...query, data: query.data?.data[0] };
};

export default usePreviousSuccessfulBuild;
